import React from 'react';
import BaseballComp from './Baseball.component';

class Baseball extends React.Component {
    componentDidMount() {
        BaseballComp();
    }
    render() {
        return (
            <div>
            </div>
        )
    }
}

export default Baseball;